import styles from "./deadline-widget.module.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flex, Spin, Collapse, Empty } from "antd";

import Widget from "@/components/ui/Widget";
import EmployeeProfile from "@/components/cards/EmployeeProfile";

import ExclamationCircleIcon from "@/icons/ExclamationCircleIcon";

import { getDeadlines } from "@/api/widgets";
import { formateISODateToStrMin } from "@/utils";
import routes from "@/routes";

const DeadlineWidget = ({ type_filter }) => {
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [type_filter]);

  const fetchData = async () => {
    setPending(true);

    try {
      const data = await getDeadlines({ type_filter });
      setData(formatData(data));
    } catch (error) {
      console.log("error", error);
    } finally {
      setPending(false);
    }
  };

  const formatData = (data) => {
    return data.map((task) => {
      return {
        key: task.uuid,
        label: (
          <Flex gap={10} className={styles.collapse_header}>
            <div className={styles.task_number}>
              {task.task_number}
              {task.parent ? ` / ${task.parent.task_number}` : ""}
            </div>
            <div className={styles.task_name}>
              <Link to={routes.taskDetail(task.uuid)}>{task.name}</Link>
            </div>

            <div className={styles.task_date}>
              {formatDateDisplay(task.due_date)}
            </div>
          </Flex>
        ),
        children: (
          <div className={styles.task_body}>
            <Flex vertical gap={10}>
              {!!task.executor && (
                <Flex vertical gap={4}>
                  <div style={{ color: "#BBBBBB" }}>Исполнитель</div>
                  <EmployeeProfile
                    {...task.executor}
                    fullName={false}
                    avatarSize={20}
                    color="#777777"
                  />
                </Flex>
              )}

              {!!task.unit && (
                <Flex vertical gap={4} align="start">
                  <div style={{ color: "#BBBBBB" }}>Рабочая группа</div>
                  <div style={{ color: "#777777" }}>{task.unit.name}</div>
                </Flex>
              )}

              <Flex align="center" gap={4} style={{ color: "#777777" }}>
                {!!task.start_date ? (
                  <span>{formateISODateToStrMin(task.start_date)}</span>
                ) : (
                  "Не назначена"
                )}
                <span style={{ color: "#BBBBBB" }}>—</span>
                <Flex align="center" gap={4}>
                  <ExclamationCircleIcon
                    style={{ fontSize: 14, color: "#E66A25" }}
                  />
                  <span>{formateISODateToStrMin(task.due_date)}</span>
                </Flex>
              </Flex>
            </Flex>
          </div>
        ),
        showArrow: false,
        className: "contact-item",
      };
    });
  };

  const formatDateDisplay = (dateString) => {
    const taskDate = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Сравниваем только даты, не время
    const taskDateString = taskDate.toDateString();
    const todayString = today.toDateString();
    const tomorrowString = tomorrow.toDateString();

    if (taskDateString === todayString) {
      return "Сегодня";
    } else if (taskDateString === tomorrowString) {
      return "Завтра";
    } else {
      return formateISODateToStrMin(dateString);
    }
  };

  return (
    <Widget
      value="contacts"
      label="Истекает срок"
      labelSecond={data.length}
      isOpen={true}
    >
      <div className="h-100">
        {pending ? (
          <div className="spin">
            <Spin size="large" />
          </div>
        ) : (
          <>
            {!data?.length ? (
              <Empty
                image={false}
                description="Нет задач"
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            ) : (
              <Collapse
                items={data}
                bordered={false}
                className="contacts-collapse"
              />
            )}
          </>
        )}
      </div>
    </Widget>
  );
};

export default DeadlineWidget;
